var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnAppStore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95.886,
    height: 34.648,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#282828}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "gr_3537",
    "data-name": "gr 3537",
    transform: "translate(-185.309 -5336.36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path_1471",
    "data-name": "path 1471",
    style: {
      fill: "#fff"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.562 34.148H17.324c-4.494 0-8.719-1.75-11.896-4.927A16.714 16.714 0 0 1 .5 17.324c0-4.494 1.75-8.719 4.928-11.896A16.714 16.714 0 0 1 17.324.5h59.238c4.493 0 8.718 1.75 11.896 4.928a16.714 16.714 0 0 1 4.928 11.896c0 4.494-1.75 8.719-4.928 11.897a16.714 16.714 0 0 1-11.896 4.927z",
    style: {
      stroke: "none"
    },
    transform: "translate(185.309 5336.36)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.324 1c-4.36 0-8.46 1.698-11.543 4.781A16.217 16.217 0 0 0 1 17.324c0 4.36 1.698 8.46 4.781 11.543a16.217 16.217 0 0 0 11.543 4.781h59.238c4.36 0 8.46-1.698 11.542-4.78a16.217 16.217 0 0 0 4.782-11.544c0-4.36-1.698-8.46-4.782-11.543A16.217 16.217 0 0 0 76.562 1H17.324m0-1h59.238c9.567 0 17.324 7.756 17.324 17.324 0 9.568-7.757 17.324-17.324 17.324H17.324C7.756 34.648 0 26.892 0 17.324 0 7.756 7.756 0 17.324 0z",
    style: {
      fill: "#969696",
      stroke: "none"
    },
    transform: "translate(185.309 5336.36)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gr_3284",
    "data-name": "gr 3284",
    transform: "translate(202.86 5344.743)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gr_3282",
    "data-name": "gr 3282"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gr_3281",
    "data-name": "gr 3281"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path_1437",
    "data-name": "path 1437",
    className: "cls-2",
    d: "M53.978 87.847a3.783 3.783 0 0 1 1.8-3.175 3.874 3.874 0 0 0-3.055-1.651c-1.285-.135-2.531.768-3.186.768s-1.676-.755-2.76-.732a4.067 4.067 0 0 0-3.425 2.086c-1.479 2.562-.376 6.328 1.043 8.4.709 1.015 1.537 2.148 2.622 2.108 1.061-.044 1.459-.678 2.74-.678s1.64.678 2.747.651c1.138-.017 1.856-1.019 2.54-2.042a8.341 8.341 0 0 0 1.163-2.365 3.661 3.661 0 0 1-2.229-3.37z",
    transform: "translate(-42.655 -78.987)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_1438",
    "data-name": "path 1438",
    className: "cls-2",
    d: "M50.389 82.551a3.726 3.726 0 0 0 .853-2.67 3.791 3.791 0 0 0-2.454 1.269 3.547 3.547 0 0 0-.875 2.572 3.134 3.134 0 0 0 2.476-1.171z",
    transform: "translate(-41.156 -79.881)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "gr_3283",
    "data-name": "gr 3283",
    transform: "translate(20.809 6.022)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path_1439",
    "data-name": "path 1439",
    className: "cls-2",
    d: "M64.193 90.55H63.11l-.593-1.865h-2.062l-.565 1.865h-1.056l2.044-6.35h1.263zm-1.854-2.65-.539-1.653q-.087-.255-.322-1.2h-.018c-.064.27-.163.669-.3 1.2l-.527 1.653z",
    transform: "translate(-58.834 -84.108)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_1440",
    "data-name": "path 1440",
    className: "cls-2",
    d: "M68.068 87.833a2.608 2.608 0 0 1-.63 1.846 1.845 1.845 0 0 1-1.4.6 1.4 1.4 0 0 1-1.3-.651h-.019v2.412H63.7v-4.933q0-.735-.039-1.507h.9l.055.725h.019a1.81 1.81 0 0 1 2.9-.179 2.521 2.521 0 0 1 .533 1.687zm-1.037.037a1.883 1.883 0 0 0-.3-1.1 1.041 1.041 0 0 0-.885-.451 1.058 1.058 0 0 0-.683.25 1.153 1.153 0 0 0-.4.655 1.37 1.37 0 0 0-.048.31v.763a1.227 1.227 0 0 0 .306.844 1.017 1.017 0 0 0 .8.343 1.043 1.043 0 0 0 .9-.442 1.947 1.947 0 0 0 .31-1.172z",
    transform: "translate(-57.453 -83.735)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_1441",
    "data-name": "path 1441",
    className: "cls-2",
    d: "M72.161 87.833a2.6 2.6 0 0 1-.63 1.846 1.847 1.847 0 0 1-1.4.6 1.4 1.4 0 0 1-1.3-.651h-.018v2.412h-1.021v-4.933q0-.735-.039-1.507h.9l.057.725h.019a1.809 1.809 0 0 1 2.9-.179 2.521 2.521 0 0 1 .532 1.687zm-1.035.037a1.883 1.883 0 0 0-.3-1.1 1.041 1.041 0 0 0-.885-.451 1.058 1.058 0 0 0-.683.25 1.16 1.16 0 0 0-.4.655 1.357 1.357 0 0 0-.046.31v.763a1.226 1.226 0 0 0 .3.844 1.015 1.015 0 0 0 .8.343 1.039 1.039 0 0 0 .894-.442 1.938 1.938 0 0 0 .319-1.172z",
    transform: "translate(-56.282 -83.735)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_1442",
    "data-name": "path 1442",
    className: "cls-2",
    d: "M76.633 88.793a1.691 1.691 0 0 1-.563 1.317 2.5 2.5 0 0 1-1.73.557 3.015 3.015 0 0 1-1.645-.4l.235-.846a2.789 2.789 0 0 0 1.47.405 1.4 1.4 0 0 0 .9-.26.85.85 0 0 0 .319-.693.885.885 0 0 0-.264-.652 2.483 2.483 0 0 0-.876-.49q-1.667-.621-1.667-1.82a1.612 1.612 0 0 1 .584-1.284 2.307 2.307 0 0 1 1.555-.5 3.075 3.075 0 0 1 1.439.3l-.253.83a2.505 2.505 0 0 0-1.215-.292 1.233 1.233 0 0 0-.837.264.753.753 0 0 0-.255.575.777.777 0 0 0 .292.621 3.28 3.28 0 0 0 .923.49 3.135 3.135 0 0 1 1.205.772 1.622 1.622 0 0 1 .383 1.106z",
    transform: "translate(-54.868 -84.129)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_1443",
    "data-name": "path 1443",
    className: "cls-2",
    d: "M78.991 86.6h-1.12v2.222c0 .565.2.848.593.848a1.789 1.789 0 0 0 .453-.048l.027.773a2.307 2.307 0 0 1-.791.113 1.221 1.221 0 0 1-.941-.368 1.808 1.808 0 0 1-.34-1.235V86.6H76.2v-.764h.668v-.837l1-.3v1.138h1.12z",
    transform: "translate(-53.863 -83.967)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_1444",
    "data-name": "path 1444",
    className: "cls-2",
    d: "M83.3 87.852a2.513 2.513 0 0 1-.6 1.732 2.154 2.154 0 0 1-1.677.7 2.049 2.049 0 0 1-1.605-.669 2.437 2.437 0 0 1-.6-1.686 2.48 2.48 0 0 1 .617-1.741 2.132 2.132 0 0 1 1.662-.679 2.085 2.085 0 0 1 1.619.67 2.406 2.406 0 0 1 .584 1.673zm-1.056.032a2.055 2.055 0 0 0-.273-1.086 1 1 0 0 0-.913-.549 1.018 1.018 0 0 0-.932.549 2.092 2.092 0 0 0-.273 1.1 2.059 2.059 0 0 0 .273 1.086 1.04 1.04 0 0 0 1.837-.009 2.067 2.067 0 0 0 .283-1.091z",
    transform: "translate(-53.115 -83.735)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_1445",
    "data-name": "path 1445",
    className: "cls-2",
    d: "M85.419 86.5a1.71 1.71 0 0 0-.322-.028.962.962 0 0 0-.828.405 1.52 1.52 0 0 0-.255.9v2.4H83l.009-3.136q0-.791-.039-1.442h.886l.037.876h.028a1.575 1.575 0 0 1 .508-.725 1.235 1.235 0 0 1 .736-.244 1.53 1.53 0 0 1 .255.019z",
    transform: "translate(-51.927 -83.735)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_1446",
    "data-name": "path 1446",
    className: "cls-2",
    d: "M89.315 87.674a2.346 2.346 0 0 1-.037.462h-3.051a1.329 1.329 0 0 0 .442 1.037 1.511 1.511 0 0 0 1 .319 3.353 3.353 0 0 0 1.233-.216l.159.706a3.809 3.809 0 0 1-1.534.283 2.219 2.219 0 0 1-1.672-.626 2.318 2.318 0 0 1-.607-1.681 2.623 2.623 0 0 1 .565-1.723 1.951 1.951 0 0 1 1.6-.734 1.7 1.7 0 0 1 1.5.734 2.464 2.464 0 0 1 .402 1.439zm-.97-.264a1.39 1.39 0 0 0-.2-.782.892.892 0 0 0-.812-.423.964.964 0 0 0-.809.414 1.512 1.512 0 0 0-.3.791z",
    transform: "translate(-51.276 -83.737)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnAppStore);
export default __webpack_public_path__ + "static/media/btn_app_store.95a9989b.svg";
export { ForwardRef as ReactComponent };